import React, { useState, useCallback } from 'react';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Get_Managers } from '../../services/oprations/Manager';
import { Get_Users ,Get_Managers_User} from '../../services/oprations/Users';
import { Get_Org_Devices } from '../../services/oprations/Device';
import { profile } from '../../services/oprations/Auth';
import { UnReadcount_Notification } from '../../services/oprations/Bussiness_Logic';
import ManagerManagement from '../../components/Organization/Org_Dashboard/ManagerSection';
import ProfileOverview from '../../components/Organization/Org_Dashboard/ProfileSection';
import UserManagement from '../../components/User/UserSection';
import DeviceManagement from '../../components/Organization/Org_Dashboard/DeviceSection';
import StandardSpinner from '../../utils/Spinner';
import Analaytics from '../../components/Organization/Manager_Dashboard/Analaytics';
import NotificationCenter from '../../components/Organization/Org_Dashboard/Notification';
import AttendanceManagement from '../../components/Organization/Manager_Dashboard/Attendance_Section';
import OrgTransactionHistory from '../../components/Organization/Org_Dashboard/TransactionManagement';
import useSocket from '../../hooks/useSocket';
import { useTheme } from '../../Context/themeContext';

import { HiOutlineBell, HiOutlineMenu, HiOutlineX } from 'react-icons/hi';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { FaFingerprint } from "react-icons/fa";
import { MdDashboard, MdPeople, MdDevices } from 'react-icons/md';
import { FiSettings } from 'react-icons/fi';
import { ArrowRightLeft } from 'lucide-react';

const Dashboard = () => {
    const { theme } = useTheme();
    const token = localStorage.getItem('token');
    const socket = useSocket();
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState('overview');
    const [unreadcount, setUnReadCount] = useState(0);
    const [loading, setloading] = useState(true);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const { user } = useSelector((state) => state.profile);
    const userDetails = typeof user == 'string' ? JSON.parse(user) : user;

    // Theme-aware classes
    const isDark = theme === 'dark';
    
    const bgPrimary = isDark ? 'bg-richblue-950' : 'bg-gray-50';
    const bgSidebar = isDark ? 'bg-richblue-950' : 'bg-white';
    const bgDrawer = isDark ? 'bg-[#0B0F1C]' : 'bg-white';
    //const bgCard = isDark ? 'bg-blue-900/20' : 'bg-blue-50';
    const bgHover = isDark ? 'hover:bg-blue-900/30' : 'hover:bg-gray-100';
    const bgActive = isDark ? 'bg-blue-600' : 'bg-blue-500';
    const bgTabBar = isDark ? 'bg-[#0B0F1C]/95' : 'bg-white/95';
    const bgDrawerHover = isDark ? 'hover:bg-blue-900/40' : 'hover:bg-gray-100';
    const bgUserStrip = isDark ? 'bg-blue-900/20' : 'bg-blue-50';
    
    const borderColor = isDark ? 'border-blue-900/50' : 'border-gray-200';
    //const borderLight = isDark ? 'border-blue-900/60' : 'border-gray-300';
    const borderTab = isDark ? 'border-blue-900/50' : 'border-gray-200';
    const borderDrawer = isDark ? 'border-blue-800/40' : 'border-blue-200';
    
    const textPrimary = isDark ? 'text-white' : 'text-gray-900';
    //const textSecondary = isDark ? 'text-blue-300' : 'text-gray-600';
    //const textMuted = isDark ? 'text-blue-400' : 'text-gray-500';
    //const textBlue = isDark ? 'text-blue-400' : 'text-blue-600';
    //const textBlueLight = isDark ? 'text-blue-300' : 'text-gray-700';
    const textTabInactive = isDark ? 'text-blue-500 hover:text-blue-300' : 'text-gray-500 hover:text-gray-700';
    const textTabActive = isDark ? 'text-blue-100' : 'text-blue-800';
    const textGradient = isDark 
        ? 'from-blue-400 to-blue-600'
        : 'from-blue-500 to-blue-700';
    
    const shadowColor = isDark ? 'shadow-blue-600/25' : 'shadow-blue-500/20';
    const shadowSidebar = isDark ? 'shadow-2xl' : 'shadow-xl';
    //const shadowGradient = isDark ? 'shadow-blue-600/20' : 'shadow-blue-500/15';

    const fetchNotifications =useCallback( async () => {
        const res = await dispatch(UnReadcount_Notification(token));
        if (res?.data?.success) setUnReadCount(res?.data?.data);
    },[dispatch, token]);

    useEffect(() => {
        dispatch(Get_Managers(token));
        dispatch(Get_Users(token));
        dispatch(Get_Org_Devices(token));
        dispatch(profile(token));
        fetchNotifications();
        setTimeout(() => setloading(false), 800);
    }, [dispatch, fetchNotifications, token]);

    useEffect(() => {
        if (!socket) return;
        socket.on('Notification_Status', () => fetchNotifications());
        socket.on('Delete_User',(data)=>{
            console.log("Delete User Socket Response Org:", data);
            dispatch(Get_Managers_User())
        })
        socket.on('Attendance_Status', (data) => console.log(data));
        socket.on('Enrollment_Status', () => {});
        return () => {
            socket.off("Notification_Status");
            socket.off("Attendance_Status");
            socket.off("Enrollment_Status");
        };
    }, [socket, dispatch, token, fetchNotifications]);

    const allNavItems = [
        { id: 'overview',     label: 'Overview',     icon: MdDashboard },
        { id: 'managers',     label: 'Managers',     icon: HiOutlineUserGroup },
        { id: 'users',        label: 'Users',        icon: MdPeople },
        { id: 'devices',      label: 'Devices',      icon: MdDevices },
        { id: 'attendance',   label: 'Attendance',   icon: FaFingerprint },
        { id: 'transactions', label: 'Transactions', icon: ArrowRightLeft },
        { id: 'Settings',     label: 'Settings',     icon: FiSettings },
    ];

    // First 4 shown in bottom tab bar; rest accessible via drawer
    const bottomTabs = allNavItems.slice(0, 4);
    const moreTabIds = ['attendance', 'transactions', 'Settings'];
// eslint-disable-next-line
    const pageTitle = {
        overview:     'Dashboard Overview',
        managers:     'Manager Management',
        users:        'User Management',
        devices:      'Device Management',
        attendance:   'Attendance Management',
        transactions: 'Transaction History',
        Settings:     'Profile Settings',
    };

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        setIsSidebarOpen(false);
    };

    if (loading) return <StandardSpinner />;

    return (
        <div className={`min-h-screen ${bgPrimary} transition-colors duration-300`}>

            {/* ── DESKTOP SIDEBAR ───────────────────────────────────────── */}
            <div className={`fixed top-0 left-0 z-40 flex-col hidden w-64 h-full border-r lg:flex ${bgSidebar} ${borderColor} transition-colors duration-300`}>
                <div className={`flex items-center p-6 border-b ${borderColor}`}>
                    <h2 className={`text-xl font-bold text-transparent bg-gradient-to-r ${textGradient} bg-clip-text`}>
                        Dashboard
                    </h2>
                </div>

                <div className="flex-1 p-4 overflow-y-auto">
                    <nav className="space-y-2">
                        {allNavItems.filter(i => i.id !== 'Settings').map(({ id, label, icon: Icon }) => (
                            <button
                                key={id}
                                onClick={() => handleTabChange(id)}
                                className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg font-medium transition-all duration-200
                                    ${activeTab === id
                                        ? `${bgActive} text-white shadow-lg ${shadowColor}`
                                        : `${isDark ? 'text-blue-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'} ${bgHover}`
                                    }`}
                            >
                                <Icon className="flex-shrink-0 w-5 h-5" />
                                <span className="flex-1 text-left">{label}</span>
                                {activeTab === id && <div className="w-1.5 h-1.5 rounded-full bg-white" />}
                            </button>
                        ))}
                    </nav>

                    <div className={`pt-6 mt-6 space-y-2 border-t ${borderColor}`}>
                        <button
                            onClick={() => setIsNotificationOpen(true)}
                            className={`relative flex items-center w-full gap-3 px-4 py-3 transition-all duration-200 rounded-lg ${isDark ? 'text-blue-300 hover:text-white hover:bg-blue-900/30' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'}`}
                        >
                            <HiOutlineBell className="w-5 h-5" />
                            <span className="flex-1 text-left">Notifications</span>
                            {unreadcount > 0 && (
                                <span className="flex items-center justify-center w-5 h-5 text-xs text-white bg-red-500 rounded-full">
                                    {unreadcount}
                                </span>
                            )}
                        </button>
                        <button
                            onClick={() => handleTabChange('Settings')}
                            className={`flex items-center w-full gap-3 px-4 py-3 rounded-lg transition-all duration-200
                                ${activeTab === 'Settings'
                                    ? `${bgActive} text-white`
                                    : `${isDark ? 'text-blue-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'} ${bgHover}`
                                }`}
                        >
                            <FiSettings className="w-5 h-5" />
                            <span className="flex-1 text-left">Settings</span>
                        </button>
                    </div>
                </div>

                <div className={`p-4 border-t ${borderColor}`}>
                    <div className={`flex items-center gap-3 px-2 py-2 transition-all rounded-lg cursor-pointer ${bgHover}`}>
                        <div className="flex items-center justify-center flex-shrink-0 w-10 h-10 font-bold text-white rounded-full bg-gradient-to-br from-blue-500 to-blue-700">
                            {userDetails?.org_name?.charAt(0) || userDetails?.manager_name?.charAt(0) || 'U'}
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className={`text-sm font-medium ${textPrimary} truncate`}>
                                {userDetails?.org_name || userDetails?.manager_name || 'User'}
                            </p>
                            <p className={`text-xs ${isDark ? 'text-blue-400' : 'text-gray-500'} truncate`}>
                                {userDetails?.org_email || userDetails?.manager_email || ''}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── MOBILE SLIDE-IN DRAWER ────────────────────────────────── */}
            <div className={`
                lg:hidden fixed top-0 left-0 z-50 w-72 h-full flex flex-col
                ${bgDrawer} ${isDark ? 'border-r border-blue-900/60' : 'border-r border-gray-300'} ${shadowSidebar}
                transition-transform duration-300 ease-in-out
                ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
            `}>
                <div className={`flex items-center justify-between px-5 py-4 border-b ${borderColor}`}>
                    <h2 className="text-lg font-bold text-transparent bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text">
                        Navigation
                    </h2>
                    <button
                        onClick={() => setIsSidebarOpen(false)}
                        className={`p-2 transition-colors rounded-lg ${isDark ? 'text-blue-300 hover:bg-blue-900/40 hover:text-white' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'}`}
                    >
                        <HiOutlineX className="w-5 h-5" />
                    </button>
                </div>

                {/* User info strip */}
                <div className={`flex items-center gap-3 px-4 py-3 mx-3 mt-3 border rounded-xl ${bgUserStrip} ${borderDrawer}`}>
                    <div className="flex items-center justify-center flex-shrink-0 w-10 h-10 font-bold text-white rounded-full bg-gradient-to-br from-blue-500 to-blue-700">
                        {userDetails?.org_name?.charAt(0) || userDetails?.manager_name?.charAt(0) || 'U'}
                    </div>
                    <div className="flex-1 min-w-0">
                        <p className={`text-sm font-semibold ${textPrimary} truncate`}>
                            {userDetails?.org_name || userDetails?.manager_name || 'User'}
                        </p>
                        <p className={`text-xs ${isDark ? 'text-blue-400' : 'text-blue-600'} truncate`}>
                            {userDetails?.org_email || userDetails?.manager_email || ''}
                        </p>
                    </div>
                </div>

                <div className="flex-1 p-3 mt-3 space-y-1 overflow-y-auto">
                    {allNavItems.map(({ id, label, icon: Icon }) => (
                        <button
                            key={id}
                            onClick={() => handleTabChange(id)}
                            className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-xl text-sm font-medium transition-all duration-200
                                ${activeTab === id
                                    ? `${bgActive} text-white shadow-lg ${shadowColor}`
                                    : `${isDark ? 'text-blue-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'} ${bgDrawerHover}`
                                }`}
                        >
                            <Icon className="flex-shrink-0 w-5 h-5" />
                            <span className="flex-1 text-left">{label}</span>
                            {activeTab === id && <div className="w-1.5 h-1.5 rounded-full bg-white" />}
                        </button>
                    ))}

                    <button
                        onClick={() => { setIsNotificationOpen(true); setIsSidebarOpen(false); }}
                        className={`relative w-full flex items-center gap-3 px-4 py-3.5 rounded-xl text-sm font-medium transition-all duration-200 ${isDark ? 'text-blue-300 hover:text-white hover:bg-blue-900/30' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'}`}
                    >
                        <HiOutlineBell className="flex-shrink-0 w-5 h-5" />
                        <span className="flex-1 text-left">Notifications</span>
                        {unreadcount > 0 && (
                            <span className="flex items-center justify-center w-5 h-5 text-xs text-white bg-red-500 rounded-full">
                                {unreadcount}
                            </span>
                        )}
                    </button>
                </div>
            </div>

            {/* Drawer backdrop */}
            {isSidebarOpen && (
                <div
                    className="fixed inset-0 z-40 lg:hidden bg-black/60 backdrop-blur-sm"
                    onClick={() => setIsSidebarOpen(false)}
                />
            )}

            {/* ── MAIN CONTENT ─────────────────────────────────────────── */}
            <div className="lg:ml-64">
                <div className="px-4 mx-auto sm:px-6 md:px-8
                               pt-[128px] pb-24
                               lg:pt-8 lg:pb-8">

                    <div className="hidden mb-14 lg:block">
                        {/* Empty - header handled elsewhere */}
                    </div>

                    <div className="space-y-6 sm:space-y-8">
                        {activeTab === 'overview'     && <Analaytics />}
                        {activeTab === 'managers'     && <ManagerManagement />}
                        {activeTab === 'users'        && <UserManagement />}
                        {activeTab === 'devices'      && <DeviceManagement />}
                        {activeTab === 'attendance'   && <AttendanceManagement />}
                        {activeTab === 'transactions' && <OrgTransactionHistory />}
                        {activeTab === 'Settings'     && <ProfileOverview />}
                    </div>
                </div>
            </div>

            {/* ── MOBILE BOTTOM TAB BAR ─────────────────────────────────── */}
            <div className={`lg:hidden fixed bottom-0 left-0 right-0 z-30 ${bgTabBar} backdrop-blur-xl border-t ${borderTab} transition-colors duration-300`}>
                <div className="flex items-center justify-around px-1 py-1.5">
                    {bottomTabs.map(({ id, label, icon: Icon }) => (
                        <button
                            key={id}
                            onClick={() => handleTabChange(id)}
                            className={`flex flex-col items-center gap-0.5 px-2 py-2 rounded-xl transition-all duration-200 flex-1
                                ${activeTab === id
                                    ? textTabActive
                                    : textTabInactive
                                }`}
                        >
                            <div className={`p-1.5 rounded-lg transition-all duration-200 ${activeTab === id ? (isDark ? 'bg-blue-600/25' : 'bg-blue-100') : ''}`}>
                                <Icon className="w-5 h-5" />
                            </div>
                            <span className="text-[10px] font-medium leading-tight">{label}</span>
                            {activeTab === id && <div className={`w-1 h-1 rounded-full ${isDark ? 'bg-blue-400' : 'bg-blue-500'} mt-0.5`} />}
                        </button>
                    ))}

                    {/* "More" opens the full drawer */}
                    <button
                        onClick={() => setIsSidebarOpen(true)}
                        className={`flex flex-col items-center gap-0.5 px-2 py-2 rounded-xl transition-all duration-200 flex-1
                            ${moreTabIds.includes(activeTab)
                                ? textTabActive
                                : textTabInactive
                            }`}
                    >
                        <div className={`p-1.5 rounded-lg transition-all duration-200 ${moreTabIds.includes(activeTab) ? (isDark ? 'bg-blue-600/25' : 'bg-blue-100') : ''}`}>
                            <HiOutlineMenu className="w-5 h-5" />
                        </div>
                        <span className="text-[10px] font-medium leading-tight">More</span>
                        {moreTabIds.includes(activeTab) && <div className={`w-1 h-1 rounded-full ${isDark ? 'bg-blue-400' : 'bg-blue-500'} mt-0.5`} />}
                    </button>
                </div>
            </div>

            <NotificationCenter
                isOpen={isNotificationOpen}
                onClose={() => setIsNotificationOpen(false)}
            />
        </div>
    );
};

export default Dashboard;
